export default "__VITE_ASSET__133c0ab0__"